import PropTypes from "prop-types";
import React from "react";
import colors from "styles/colors";
import styled from "styled-components";

const Icon = ({ className, name, color, size, onClick, transform }) => {
  return (
    <StyledIcon
      className={className ? `${name} ${className}` : name}
      color={color}
      size={size}
      onClick={onClick}
      transform={transform}
    />
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  transform: PropTypes.string,
};

export default Icon;

const StyledIcon = styled.i.attrs((props) => ({
  color: props.color || colors.mainText,
  size: props.size || "20px",
  cursor: props.onClick ? "pointer" : "",
  transform: props.transform ? props.transform : "",
}))`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  cursor: ${(props) => props.cursor};
  transform: ${(props) => props.transform};
`;
